import React, { useEffect } from 'react'
import { LntSwitch } from '@app/components/base'

import { SIZE } from '@app/constants'

import type { Column } from '@app/components/base/Table/types'
import type { PatchMonitoringValidationResultsConfigData } from '@app/api/routes/monitoringValidation/types'
import type { CheckingPricesCompetitorsDataSource } from '@app/pages/CheckingPricesCompetitorsPage/types'

export const useConfigValueColumn = (
  columns: Array<Column<CheckingPricesCompetitorsDataSource>>,
  onChange: (data: PatchMonitoringValidationResultsConfigData) => void
): void => {
  useEffect(() => {
    const configValueColumn = columns.find(column => column.key === 'configValue')

    if (configValueColumn) {
      configValueColumn.render = (_, { configValue, key }) => {
        return (
          <LntSwitch
            size={ SIZE.small }
            checked={ configValue }
            onChange={ value => onChange({ [key]: value }) }
          />
        )
      }
    }
  }, [])
}
